import { Button, HStack, Text } from '@chakra-ui/react'

interface Props {
  offset: number
  limit: number
  total: number
  hasMore: boolean
  onPageChange: (offset: number) => void
  isLoading: boolean
}

export default function QueryResultsPagination({
  offset,
  limit,
  total,
  hasMore,
  onPageChange,
  isLoading,
}: Props) {
  if (total === 0) return null

  const currentPage = Math.floor(offset / limit) + 1
  const totalPages = Math.ceil(total / limit)
  const startItem = offset + 1
  const endItem = Math.min(offset + limit, total)

  const handlePrevious = () => {
    if (offset > 0) {
      onPageChange(Math.max(0, offset - limit))
    }
  }

  const handleNext = () => {
    if (hasMore) {
      onPageChange(offset + limit)
    }
  }

  return (
    <HStack justify='space-between' align='center' py={2}>
      <Text fontSize='sm' color='gray.600'>
        Showing {startItem}-{endItem} of {total} results
      </Text>
      <HStack spacing={2}>
        <Button
          size='sm'
          onClick={handlePrevious}
          isDisabled={offset === 0 || isLoading}
        >
          Previous
        </Button>
        <Text fontSize='sm'>
          Page {currentPage} of {totalPages}
        </Text>
        <Button
          size='sm'
          onClick={handleNext}
          isDisabled={!hasMore || isLoading}
        >
          Next
        </Button>
      </HStack>
    </HStack>
  )
}
